import { getRightsForOrderManage } from 'feature/appeals/helpers/getRightsForOrderManage'
import { AppealStatus } from 'feature/appeals/type'
import { MenuBlock } from 'ui'

import { TOrderManageType } from '../ModalOrderManage'

import style from './OrderManageMenu.module.scss'

type TMainOrderManage = {
  changeOrderManageType: (type: TOrderManageType) => void
  orderStatus: AppealStatus
  hasPaidOrder: boolean
}

// меню для формы упраления заявкой

export function OrderManageMenu({
  changeOrderManageType,
  orderStatus,
  hasPaidOrder,
}: TMainOrderManage) {
  return (
    <>
      <span className='h2'>управление заказом</span>
      <div className={style.orderManageMenu}>
        {getRightsForOrderManage('cancel', orderStatus) && !hasPaidOrder && (
          <MenuBlock
            text='Отменить заказ'
            className={style.orderManageItem}
            handleClick={() => changeOrderManageType('cancel')}
            data-testid='manage-cancel-order'
          />
        )}

        {getRightsForOrderManage('dealer', orderStatus) && (
          <MenuBlock
            text='Пожаловаться на дилера'
            className={style.orderManageItem}
            handleClick={() => changeOrderManageType('dealer')}
            data-testid='manage-complain-dealer'
          />
        )}
        {getRightsForOrderManage('changeVisit', orderStatus) && (
          <MenuBlock
            text={'Перенести время заказа'}
            className={style.orderManageItem}
            handleClick={() => changeOrderManageType('changeVisit')}
            data-testid='manage-reschedule-order'
          />
        )}
      </div>
    </>
  )
}
